import * as React from 'react';
import * as Modal from 'react-modal';

import { Bubbles, Close } from '../../../icons';
import { trackFeedbackSucceed } from '../../tracking';
import * as styles from './styles/styles.css';

interface IPopupFeedbackSentProps {
  isOpen: boolean;
  onClose(): void;
}

let isFirstSend = true;

export function PopupFeedbackSent({ isOpen, onClose }: IPopupFeedbackSentProps) {
  if (isOpen && isFirstSend) {
    trackFeedbackSucceed();
    isFirstSend = false;
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      style={{
        content: {
          background: 'white',
          border: '1px solid rgb(204, 204, 204)',
          borderRadius: 4,
          bottom: 40,
          left: 40,
          outline: 'none',
          overflow: 'visible',
          padding: 0,
          position: 'static',
          right: 40,
          top: 40,
          width: 500,
          zIndex: 101,
        },
        overlay: {
          alignItems: 'center',
          backgroundColor: 'rgba(24, 41, 48, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 100,
        },
      }}
    >
      <div className={styles['body']}>
        <div onClick={onClose} className={styles['close_icon']}>
          <Close />
        </div>

        <div className={styles['image']}>
          <Bubbles />
        </div>

        <div className={styles['bold']}>Спасибо за отзыв</div>
      </div>
    </Modal>
  );
}
